import React from "react";
import WebNewsPageGen from "./generated/WebNewsPageGen";
import webNewsService from "../../../services/legacy/webNewsService";



const WebNewsPage = () => {
  const service = webNewsService;
  return <WebNewsPageGen service={service} />;
};

export default WebNewsPage;